import { useCallback, useState } from "react";
import { AssemblySim } from "./AssemblySim";
import { KITS } from "@/lib/assemblyKits";
import { KIT_PHOTOS } from "@/lib/labParts";
import { HoverSim } from "./simsMotion";
import { FlightSim, RaceSim, GimbalSim } from "./simsFlight";
import { CanSatSim, AeroSim } from "./simsAero";
import { HousemaidSim, SecuritySim, PickPlaceSim } from "./simsRobots";
import { HomeHubSim, HotelSim, VoiceHomeSim } from "./simsHome";

const assembly = (kit) => {
  const Comp = ({ onSuccess }) => <AssemblySim kit={KITS[kit]} photos={KIT_PHOTOS[kit]} onComplete={onSuccess} />;
  return Comp;
};

const HexaLab = ({ onSuccess }) => {
  const [built, setBuilt] = useState(false);
  const onBuilt = useCallback(() => setBuilt(true), []);
  return built ? (
    <div className="space-y-3">
      <p className="rounded-xl bg-[#DDF6E8] text-[#137A43] px-4 py-2 text-sm font-semibold" data-testid="hexa-hover-stage">Build complete ✓ Stage 2: switch Auto-hold on and tune the gain to hover at the target height.</p>
      <HoverSim onSuccess={onSuccess} />
    </div>
  ) : <AssemblySim kit={KITS.hexa} photos={KIT_PHOTOS.hexa} onComplete={onBuilt} />;
};

export const LAB_SIMS = {
  "drone-assembly": assembly("quad"), "quad-flight-training": FlightSim, "hexacopter-build": HexaLab, "fpv-racing": RaceSim,
  "humanoid-assembly": assembly("humanoid"), "housemaid-robot": HousemaidSim, "security-robot": SecuritySim, "luxeray-home-15": HomeHubSim,
  "luxeray-hotel-25": HotelSim, "cansat-launch": CanSatSim, "cubesat-assembly": assembly("cubesat"), "arm-pick-place": PickPlaceSim,
  "voice-home": VoiceHomeSim, "gimbal-stabilization": GimbalSim, "aerospace-intro": AeroSim,
};
